export const ITEMS_KEY = 'been-web:items'

export const DB_NAME = 'been-web'

export const DB_VERSION = 2

export const MEDIA_STORE = 'media'

export const EMBED_SET_DATA = 'been-web:set-data'

export const EMBED_DATA_READY = 'been-web:ready'

export const EMBED_DATA_ERROR = 'been-web:error'

export const LOCAL_DB = 'indexeddb'